import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfilePhotoService } from 'src/app/services/profile-photo.service';

/** `userId | profilePhoto: fallback | async` → a presigned photo link, or the fallback when there is none. */
@Pipe({ name: 'profilePhoto' })
export class ProfilePhotoPipe implements PipeTransform {
  constructor(private profilePhotoService: ProfilePhotoService) {}

  transform(userId: string | null | undefined, fallback: string | null = null): Observable<string | null> {
    return this.profilePhotoService.url$(userId).pipe(map((url) => url ?? fallback));
  }
}
